module.exports = __webpack_public_path__ + "img/logo.5e3bc595.png";